import SET_LOADING from "./setLoading";
import UNSET_LOADING from "./unsetLoading";

export default {
  SET_LOADING,
  UNSET_LOADING
};
